import { render } from "./TrainingSchemes.vue?vue&type=template&id=66287a3a"
import script from "./TrainingSchemes.vue?vue&type=script&lang=js"
export * from "./TrainingSchemes.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__